import Deployment from "./Deployment";
import GitFlow from "./GitFlow";
import GraphQL from "./GraphQL";
import TestFlight from "./TestFlight";
import JMeter from "./JMeter/JMeter";
import Reuniones from "./Reuniones";
import Documentacion from "./Documentacion";
import Componetizacion from "./Componetizacion";
import Dependencias from "./Dependencias";
import Jira from "./Jira";
import NativeModules from "./NativeModules";
import CodeReview from "./CodeReview";
import PreguntasFrecuentes from "./PreguntasFrecuentes";
import JiraTracking from "./JiraTracking";
import Test from "./Testing";

const Contents = [
  GitFlow,
  GraphQL,
  TestFlight,
  Test,
  Deployment,
  JMeter,
  Reuniones,
  Documentacion,
  Componetizacion,
  Dependencias,
  Jira,
  NativeModules,
  CodeReview,
  PreguntasFrecuentes,
  JiraTracking
];

export default Contents;
